import {
  ArrayInput, BooleanInput,
  FileField,
  FileInput, FormTab,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator, TabbedForm,
  TextInput
} from "react-admin";
import {useState} from "react";

export function FormsForm(props) {
  const [showUseTerms, setShowUseTerms] = useState(props.record.showUseTerms);
  return (
    <TabbedForm {...props}>
      <FormTab label={'Dados Básicos'}>
        <TextInput source="name" label={'Nome'} fullWidth validate={[required()]} />
        <TextInput source="description" label={'Descrição'} fullWidth validate={[required()]} />
        <FileInput
          source="attachment"
          label={'Anexo'}
          labelMultiple={`Anexe documentos de suporte para o preenchimento da requisição. `}
          // maxSize={5000000}
        >
          <FileField source="path" title="name" />
        </FileInput>
      </FormTab>
      <FormTab label={'Instruções de Preenchimento'}>
        <BooleanInput fullWidth onChange={e => setShowUseTerms(e)} source="showUseTerms" label={'Habilitar Instruções de Preenchimento'}  />
        <TextInput
          label={'Instruções'}
          source={'useTerms'}
          disabled={!showUseTerms}
          fullWidth
          multiline
          minRows={5}
        />
      </FormTab>
      <FormTab label={'Campos do Formulário'}>

        <ArrayInput source="fields" label="Campos">
          <SimpleFormIterator >
            <TextInput source="label" label="Questão" required  fullWidth />
            <SelectInput source="type" label="Tipo" required choices={[
              { id: 'string', name: 'Texto' },
              { id: 'file', name: 'Anexo' },
            ]} />
            <SelectInput source="mask" label="Formato" choices={[
              { id: '', name: 'Sem Formato' },
              { id: '(99) 99999-9999', name: 'Telefone' },
              { id: '999.999.999-99', name: 'CPF' },
              { id: '99.999.999/9999-99', name: 'CNPJ' },
              { id: '99/99/9999', name: 'Data' },
            ]} />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>
    </TabbedForm>
  )
}
